<template>

	    <div>
      <div class="img_icon_wrapp">
        <div class="img_wrapp_link">
          <div class="img_wrapp">
            <img v-if="item.hover.length > 1 && desktop" :src="item.hover" :alt="item.title" width="330" height="440" loading="lazy" class="bottom zoom">

            <img v-if="desktop" :src="item.thumbnail" :alt="item.title" width="330" height="440" :class="classResolve" id="main_img">
            <img v-else :src="item.thumbnailMobile" :alt="item.title" width="330" height="440" :class="classResolve" id="main_img">
          </div>
        </div>
      </div>

      <div class="txt_wrapp">
        <p class="small_product_brand" v-if="item.id <= 7988">{{ item.brandTitle }} </p>

        <!--<h2 v-if="item.htmlTitle" v-html="item.htmlTitle" class="small_product_title"></h2>-->
        <h2 v-bind:class='item.id <= 7988 ? "small_product_title title_old" : "small_product_title title_new"'> <span v-if="item.htmlTitle"> {{item.htmlTitle}} </span> {{ item.title }} </h2>

        <p class="small_product_code">{{ item.code }}</p>

        <div class="small_product_price_wrapp">
          <p v-if="item.price !== item.discountedPrice" class="small_product_price_discounted">{{ formatPrice(item.price)}} rsd</p>
	        <p class="small_product_price">{{ formatPrice(item.discountedPrice) }} rsd</p>
        </div>

        <!-- <div v-else class="small_product_price_wrapp">
          <p class="small_product_old_price">{{ formatPrice(item.price) }} rsd</p>
          <p class="small_product_price discounted">{{ formatPrice(item.discountedPrice) }} rsd</p>
        </div> -->
      </div>
	    </div>

</template>

<script>

  import accounting from 'accounting';

  export default {
    name: "ShopProduct",

	  props: [
		  'item',
		  'desktop'
	  ],

    computed: {

      /**
       *  Resolve class based on hover image.
       *
       * @returns {string}
       */
      classResolve() {

        var hover = this.item.hover;

        if (hover.length > 1) {

          return "top";
        } else {

          return "zoom";
        }
      },

      /**
       *  Resolve if add to cart button should be previewed based on items brand.
       *
       * @returns {string}
       */
      shouldDisplay() {
        if (this.item.brandTitle === 'YOKO London') {
          return false;
        } else if (this.item.brandTitle === 'Zlatara JOKIĆ') {
          return false;
        } else if (this.item.brandTitle === 'Burato') {
          return false;
        } else  {
          return true;
        }
      }
    },

    methods: {

      /**
       * Format price.
       *
       * @param value
       */
      formatPrice(value) {

        return accounting.formatMoney(value, '', 2, '.', ',')
      }

    }

  }

</script>

<style scoped>

</style>
